import { ConversationSection, ConversationSectionMsg, TypeMessage } from 'app/models/ChatModels';

const VIRTUAL_ASSISTANT_TYPES: string[] = [TypeMessage.VirtualAssistant, TypeMessage.VirtualAssistantForm];

export const isVirtualAssistantMessage = (message: any): boolean =>
  VIRTUAL_ASSISTANT_TYPES.includes(message?.attributes?.type);

/**
 * Returns the conversation section a message belongs to, or null for items that should not
 * start a new section (date separators, join / opt-in notices, concierge and system messages)
 */
const getMessageSection = (message: any, systemIdentity?: string): ConversationSection | null => {
  if (message.dateSeparator || message.joiningDate || message.isOptedIn !== undefined || message.attributes?.concierge) {
    return null;
  }

  if (systemIdentity && message.author === systemIdentity) {
    return null;
  }

  return isVirtualAssistantMessage(message) ? ConversationSection.VirtualAssistant : ConversationSection.LiveNurse;
};

/**
 * Inserts a section title every time the user switches between the Live Nurse chat and the Virtual Assistant.
 * Sections restart after each date separator. Conversations without Virtual Assistant messages are returned as is.
 */
export function insertConversationSections<T>(messages: T[], systemIdentity?: string): (T | ConversationSectionMsg)[] {
  if (!messages.some(isVirtualAssistantMessage)) {
    return messages;
  }

  const result: (T | ConversationSectionMsg)[] = [];
  let currentSection: ConversationSection | null = null;

  for (const message of messages) {
    if ((message as any).dateSeparator) {
      currentSection = null;
      result.push(message);
      continue;
    }

    const section = getMessageSection(message, systemIdentity);

    if (section && section !== currentSection) {
      result.push({ sectionTitle: section });
      currentSection = section;
    }

    result.push(message);
  }

  return result;
}
